import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=4b974b67&scoped=true"
import script from "./Filters.vue?vue&type=script&lang=js"
export * from "./Filters.vue?vue&type=script&lang=js"
import style0 from "./Filters.vue?vue&type=style&index=0&id=4b974b67&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b974b67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b974b67')) {
      api.createRecord('4b974b67', component.options)
    } else {
      api.reload('4b974b67', component.options)
    }
    module.hot.accept("./Filters.vue?vue&type=template&id=4b974b67&scoped=true", function () {
      api.rerender('4b974b67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/SingleView/Filters.vue"
export default component.exports